import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import LikeCounter from "../LikeCounter/LikeCounter";
import { useNavigate } from "react-router-dom";
import styles from "./MyItem.module.css";
import { API_BASE } from "../../../utils/api";
import { MdImageNotSupported } from "react-icons/md";
import { FaUser } from "react-icons/fa";

const MyItem = ({ id, uuid, name, img, icon, price, title, description, like, isLikedByUser, descriptor }) => {
  const navigate = useNavigate();

  const [imageError, setImageError] = useState(false);
  const [userImageError, setUserImageError] = useState(false);

  const handleClick = () => {
    navigate(`/dashboard/memory/${descriptor}`);
  };

  return (
    <Box className={styles.itemContainer} onClick={handleClick}>
      <Box className={styles.imageContainer}>
        {!icon || imageError ? (
          <Box className={styles.fallbackImageBox}>
            <MdImageNotSupported className={styles.fallbackIcon} />
            <Typography className={styles.fallbackText}>No Image</Typography>
          </Box>
        ) : (
          <img
            className={styles.itemImage}
            src={`${API_BASE}${icon}`}
            alt={title}
            onError={() => setImageError(true)}
          />
        )}
      </Box>

      <Box className={styles.infoContainer}>
        <Box className={styles.title}>{title}</Box>
        <Box className={styles.description}>{description}</Box>
        <Box className={styles.userInfo}>
          {!img || userImageError ? (
            <Box className={styles.fallbackPicIcon}>
              <FaUser className={styles.picFallbackIcon} />
            </Box>
          ) : (
            <img
              className={styles.userImage}
              src={`${API_BASE}${img}`}
              alt={name}
              onError={() => setUserImageError(true)}
            />
          )}
          <Typography className={styles.userName}>{name}</Typography>
        </Box>
        <Box className={styles.priceSection}>
          <Typography className={styles.price}>Price: ${price.toLocaleString()}</Typography>
          <LikeCounter id={id} initialLikes={like} isLiked={isLikedByUser} />
        </Box>
      </Box>
    </Box>
  );
};

MyItem.propTypes = {
  name: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  like: PropTypes.number.isRequired,
  isLikedByUser: PropTypes.bool.isRequired,
  descriptor: PropTypes.string.isRequired,
};

export default MyItem;